/* Premade3D project measurement contract. No network or storage side effects. */
(function(root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.PM3DMeasurement = factory();
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
  'use strict';
  var EVENTS = ['page_view','view_item_list','select_item','view_item','add_to_cart','remove_from_cart','view_cart','begin_checkout','add_payment_info','purchase','refund','view_promotion','select_promotion','view_offer','select_offer','offer_applied','bundle_builder_open','bundle_builder_add','bundle_builder_remove','gift_eligible','gift_selected','campaign_landing','campaign_link','outbound_link','order_access_view','order_consent_saved','download_attempt','download_link_issued','download_error'];
  var SOURCES = ['shopify_pixel','storefront','downloads_app','shopify_webhook'];
  var IDS = ['offer_id','promotion_id','link_id','placement','campaign_id','collection_id','product_kind','item_list_id','item_list_name','error_code'];
  function id(value) { return typeof value === 'string' && /^[a-zA-Z0-9][a-zA-Z0-9_.:\-]{0,99}$/.test(value) ? value : null; }
  function money(value) { return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? Math.round(value*100)/100 : null; }
  function location(value) {
    try {
      var u = new URL(value);
      if (u.protocol !== 'https:' || ['premade3d.com','www.premade3d.com','downloads.premade3d.com'].indexOf(u.hostname) < 0) return null;
      var p = u.pathname;
      if (u.hostname === 'downloads.premade3d.com') p = ['/portal','/access','/consent','/download'].indexOf(p) >= 0 ? p : '/';
      else if (/^\/checkouts?(\/|$)/.test(p)) p = '/checkout';
      else if (!/^\/(?:$|cart\/?$|products\/[a-z0-9-]+\/?$|collections(?:\/[a-z0-9-]+)?\/?$|pages\/[a-z0-9-]+\/?$|policies\/[a-z0-9-]+\/?$)/.test(p)) p = '/';
      return u.origin + p;
    } catch (_) { return null; }
  }
  function item(raw) {
    if (!raw || !id(raw.item_id)) return null;
    var out = {item_id:id(raw.item_id)};
    // Names supplied by catalog adapters must be public product names, never checkout buyer text.
    ['item_name','item_brand'].forEach(function(k) { if (typeof raw[k] === 'string' && raw[k].length <= 100 && !/[@<>\r\n]|https?:|token=/i.test(raw[k])) out[k] = raw[k]; });
    ['item_category','item_category2','item_category3','item_category4','item_category5','item_variant','promotion_id','item_list_id'].forEach(function(k) { if (id(raw[k])) out[k] = id(raw[k]); });
    ['price','discount'].forEach(function(k) { if (money(raw[k]) !== null) out[k] = money(raw[k]); });
    if (Number.isInteger(raw.quantity) && raw.quantity > 0 && raw.quantity <= 10000) out.quantity = raw.quantity;
    if (Number.isInteger(raw.index) && raw.index >= 0) out.index = raw.index;
    return out;
  }
  function sanitize(raw) {
    if (!raw || EVENTS.indexOf(raw.event_name) < 0 || SOURCES.indexOf(raw.event_source) < 0 || raw.consent_analytics !== true || raw.is_test === true || raw.is_fixture === true) return null;
    if (!id(raw.event_id)) return null;
    var page = location(raw.page_location);
    if (!page) return null;
    var out = {event:'pm3d_event',event_name:raw.event_name,event_id:id(raw.event_id),event_source:raw.event_source,consent_analytics:true,consent_marketing:raw.consent_marketing === true,page_location:page,page_referrer:'',page_title:'',ecommerce:null};
    IDS.forEach(function(k) { out[k] = id(raw[k]); });
    // Existing consented GA pseudonymous client only; not Shopify customer/client identifiers.
    if (raw.event_source === 'downloads_app' && typeof raw.client_id === 'string' && /^[0-9]{1,20}\.[0-9]{1,20}$/.test(raw.client_id)) out.client_id = raw.client_id;
    if (raw.event_source === 'downloads_app' && Number.isSafeInteger(raw.session_id) && raw.session_id > 0) out.session_id = raw.session_id;
    if (raw.ecommerce && typeof raw.ecommerce === 'object') {
      var e = {}, r = raw.ecommerce;
      if (typeof r.currency === 'string' && /^[A-Z]{3}$/.test(r.currency)) e.currency = r.currency;
      ['value','tax','shipping'].forEach(function(k) { if (money(r[k]) !== null) e[k] = money(r[k]); });
      if (id(r.transaction_id) && /^shopify_[0-9]+$/.test(r.transaction_id)) e.transaction_id = id(r.transaction_id);
      e.items = (Array.isArray(r.items) ? r.items : []).slice(0,200).map(item).filter(Boolean);
      if ('value' in e && !e.currency) return null;
      out.ecommerce = e;
    }
    if (['purchase','refund'].indexOf(raw.event_name) >= 0 && (!out.ecommerce || !out.ecommerce.transaction_id || !out.ecommerce.currency || !out.ecommerce.items.length || out.ecommerce.value === undefined)) return null;
    if (['purchase','refund'].indexOf(raw.event_name) >= 0 && ['shopify_pixel','shopify_webhook'].indexOf(raw.event_source) < 0) return null;
    // Refunds require authenticated provider receipts; do not infer them from a cancel click.
    if (raw.event_name === 'refund' && raw.event_source !== 'shopify_webhook') return null;
    if (['view_offer','select_offer','offer_applied'].indexOf(raw.event_name) >= 0 && !out.offer_id) return null;
    if (['campaign_landing','campaign_link','outbound_link'].indexOf(raw.event_name) >= 0 && !out.link_id) return null;
    return out;
  }
  function campaign(url) {
    var out = {};
    try {
      var u = new URL(url);
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id'].forEach(function(k) { var v = u.searchParams.get(k); if (id(v)) out[k] = v.toLowerCase(); });
    } catch (_) {}
    return out;
  }
  function trackedLink(base, fields, catalog) {
    catalog = catalog || {};
    function approved(list, value) { return id(value) && Array.isArray(catalog[list]) && catalog[list].indexOf(value) >= 0; }
    if (!approved('link_ids', fields.link_id) || !approved('campaign_ids', fields.utm_id)) throw new Error('Unregistered campaign or link');
    ['offer_id','promotion_id'].forEach(function(k) { if (fields[k] && !approved(k === 'offer_id' ? 'offer_ids' : 'promotion_ids', fields[k])) throw new Error('Unregistered '+k); });
    var safe = location(base); if (!safe) throw new Error('Only public Premade3D links can be tracked');
    var u = new URL(base);
    if (u.hostname === 'downloads.premade3d.com' || safe !== u.origin + u.pathname || u.search || u.hash) throw new Error('Private or unknown links cannot be campaign destinations');
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_id'].forEach(function(k) { if (!id(fields[k])) throw new Error('Invalid campaign field '+k); u.searchParams.set(k, fields[k].toLowerCase()); });
    ['link_id','offer_id','promotion_id'].forEach(function(k) { if (fields[k]) u.searchParams.set(k,fields[k]); });
    return u.href;
  }
  function createEmitter(push, readConsent) {
    return function(raw) {
      var c = readConsent() || {};
      var clean = sanitize(Object.assign({},raw,{consent_analytics:c.analytics === true,consent_marketing:c.marketing === true}));
      if (!clean) return false;
      push({ecommerce:null,pm3d_payload:null}); push({event:'pm3d_event',pm3d_payload:clean}); return true;
    };
  }
  return {events:EVENTS,sanitize:sanitize,item:item,safeLocation:location,campaign:campaign,trackedLink:trackedLink,createEmitter:createEmitter};
});

/* Decorate only registered public links. No network, event emission or campaign creation. */
(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory();else root.PM3DLinkCatalog=factory();})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';
  function lookup(href,origin,catalog){
    let u;try{u=new URL(href,origin);}catch(_){return null;}
    if(u.origin!==origin||u.protocol!=='https:'||u.search||u.hash||u.username||u.password)return null;
    return (catalog?.links||[]).find(r=>r.public_path===u.pathname&&/^[a-z0-9][a-z0-9_-]{0,95}$/.test(r.link_id))||null;
  }
  function apply(doc,origin,catalog){
    let count=0;
    for(const a of doc.querySelectorAll('a[href]')){
      if(a.dataset.pm3dLinkId)continue;
      const entry=lookup(a.getAttribute('href'),origin,catalog);if(!entry)continue;
      a.dataset.pm3dLinkId=entry.link_id;
      if(entry.offer_id)a.dataset.pm3dOfferId=entry.offer_id;
      if(!a.dataset.pm3dPlacement)a.dataset.pm3dPlacement=a.closest?.('[data-pm3d-placement]')?.dataset?.pm3dPlacement||'navigation';
      count++;
    }
    return count;
  }
  return {lookup,apply};
});

/* Main GTM runs only on known public shopping documents with registered campaign query values.
   Ad-platform click IDs are skipped, never read: the platform issued them and consent still gates every tag. Google Ads
   auto-tagging adds gad_source and gad_campaignid next to gclid, and Google's organic Shopping listings add srsltid. */
(function(root){
  'use strict';
  const CLICK_IDS=['gclid','gbraid','wbraid','gad_source','gad_campaignid','srsltid','twclid','msclkid'];
  function allowed(location,config){
    let u;try{u=new URL(location.href || location.origin+location.pathname+(location.search||'')+(location.hash||''));}catch(_){return false;}
    if(u.protocol!=='https:' || !['premade3d.com','www.premade3d.com'].includes(u.hostname) || u.username || u.password || u.port || (u.hash && !(u.pathname === '/pages/membership' && u.hash === '#asset-pack-membership')))return false;
    const path=u.pathname;
    let known=['/','/cart','/cart/','/collections','/collections/'].includes(path);
    const product=path.match(/^\/products\/([a-z0-9-]+)\/?$/);
    const collection=path.match(/^\/collections\/([a-z0-9-]+)\/?$/);
    const page=path.match(/^\/pages\/([a-z0-9-]+)\/?$/);
    if(product)known=(config.offerIds||[]).includes(product[1]);
    if(collection)known=(config.collectionIds||[]).includes(collection[1]);
    if(page)known=(config.pageIds||[]).includes(page[1]);
    if(!known)return false;
    const query=config.campaignQuery||{};
    const seen=new Set();
    for(const [key,value]of u.searchParams){
      if(seen.has(key))return false;
      seen.add(key);
      if(CLICK_IDS.includes(key))continue;
      if(!Array.isArray(query[key]) || !query[key].includes(value))return false;
    }
    return true;
  }
  root.PM3DPublicContext={allowed};
  if(typeof module==='object' && module.exports)module.exports=root.PM3DPublicContext;
})(typeof window==='object'?window:globalThis);

/* Shopify CMP remains the authority. Download consent is never analytics consent. */
(function(root) {
  'use strict';
  function install(win, doc, config) {
    if (!config || config.enabled !== true || win.__pm3dPrivacyBridge) return null;
    win.__pm3dPrivacyBridge = true;
    let loaded = false;
    win.dataLayer = win.dataLayer || [];
    function gtag() { win.dataLayer.push(arguments); }
    // Basic consent mode: do not load GTM before an explicit analytics decision.
    gtag('consent', 'default', {analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
    function read() {
      const p = win.Shopify?.customerPrivacy;
      try {
        const c = p.currentVisitorConsent();
        return { analytics: c.analytics === 'yes' && p.analyticsProcessingAllowed() === true,
          marketing: c.marketing === 'yes' && p.marketingAllowed() === true,
          explicit: ['yes','no'].includes(c.analytics) || ['yes','no'].includes(c.marketing) };
      } catch (_) { return {analytics:false,marketing:false,explicit:false}; }
    }
    function update() {
      const c = read();
      if (c.explicit) {
        const value = encodeURIComponent(JSON.stringify({v:1,analytics:c.analytics,marketing:c.marketing,updated_at:Date.now()}));
        // Shared non-identifying choice only. No session/customer/access identifiers.
        doc.cookie = 'pm3d_tracking_consent=' + value + '; Domain=premade3d.com; Path=/; Max-Age=15552000; Secure; SameSite=Lax';
      } else {
        doc.cookie = 'pm3d_tracking_consent=; Domain=premade3d.com; Path=/; Max-Age=0; Secure; SameSite=Lax';
      }
      gtag('consent', 'update', {analytics_storage:c.analytics?'granted':'denied',
        ad_storage:c.marketing?'granted':'denied',ad_user_data:c.marketing?'granted':'denied',ad_personalization:c.marketing?'granted':'denied'});
      if (!c.analytics || !win.PM3DPublicContext?.allowed(win.location,config) || loaded || !/^GTM-[A-Z0-9]+$/.test(config.gtmContainerId || '')) return;
      loaded = true;
      win.dataLayer.push({'gtm.start':Date.now(),event:'gtm.js'});
      const script = doc.createElement('script'); script.async = true;
      script.src = 'https://www.googletagmanager.com/gtm.js?id=' + config.gtmContainerId;
      doc.head.appendChild(script);
    }
    doc.addEventListener('visitorConsentCollected', update);
    doc.addEventListener('click', event => {
      if (!event.target.closest?.('[data-pm3d-privacy-preferences]')) return;
      if (typeof win.privacyBanner?.showPreferences !== 'function') return;
      event.preventDefault();
      event.stopImmediatePropagation?.(); // Own this preference action before Shopify's hash delegate.
      // Native Shopify dialog; no separate Premade3D banner or manufactured choice.
      try { win.privacyBanner?.showPreferences()?.catch(() => {}); } catch (_) {}
    }, true);
    // The API object can exist before initialization has finished.
    if (win.Shopify?.loadFeatures) {
      win.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) update(); });
    }
    update();
    return { read, update };
  }
  root.PM3DPrivacyBridge = {install};
  if (typeof module === 'object' && module.exports) module.exports = root.PM3DPrivacyBridge;
  if (root.document) {
    let config = {};
    try {config = JSON.parse(root.document.getElementById('PM3DTrackingConfig')?.textContent || '{}');} catch (_) {}
    install(root,root.document,config);
  }
})(typeof window === 'object' ? window : globalThis);

/* Premade3D: track deliberate offer/link interactions in the main GTM document.
   No third-party scripts, cookies, storage, customer data or cart/checkout interception. */
(function (root) {
  'use strict';
  function install(win, doc, config) {
    if (!config || config.enabled !== true || win.__pm3dOfferBridge) return null;
    win.__pm3dOfferBridge = true;
    const published = new WeakSet();
    let observer, landingSent = false, sequence = 0;
    const allowed = (value, list) => typeof value === 'string' && /^[a-z0-9][a-z0-9_-]{0,95}$/.test(value) && Array.isArray(list) && list.includes(value) ? value : undefined;
    function privacy() {
      const p = win.Shopify && win.Shopify.customerPrivacy;
      try { return Boolean(win.PM3DPublicContext?.allowed(win.location,config) && p && p.currentVisitorConsent().analytics === 'yes' && p.analyticsProcessingAllowed() === true); } catch (_) { return false; }
    }
    function identifiers(node) {
      const d = node.dataset || {};
      const data = {};
      const offer = allowed(d.pm3dOfferId, config.offerIds);
      const promotion = allowed(d.pm3dPromotionId, config.promotionIds);
      const link = allowed(d.pm3dLinkId, config.linkIds);
      const placement = allowed(d.pm3dPlacement, config.placements);
      if (offer) data.offer_id = offer;
      if (promotion) data.promotion_id = promotion;
      if (link) data.link_id = link;
      if (placement) data.placement = placement;
      return data;
    }
    function publish(name, data) {
      if (!privacy() || !win.PM3DMeasurement) return false;
      const p = win.Shopify.customerPrivacy;
      const clean = win.PM3DMeasurement.sanitize(Object.assign({}, data, {
        event_name: name, event_id: 'storefront_' + Date.now() + '_' + (++sequence),
        event_source: 'storefront', consent_analytics: true,
        consent_marketing: p.currentVisitorConsent().marketing === 'yes' && p.marketingAllowed() === true,
        page_location: win.location.origin + win.location.pathname
      }));
      if (!clean) return false;
      win.dataLayer = win.dataLayer || [];
      win.dataLayer.push({ ecommerce: null, pm3d_payload: null });
      win.dataLayer.push({ event: 'pm3d_event', pm3d_payload: clean });
      return true;
    }
    function landing() {
      if (landingSent || !privacy()) return;
      const query = new URLSearchParams(win.location.search);
      const data = identifiers({ dataset: {
        pm3dOfferId: query.get('offer_id'), pm3dPromotionId: query.get('promotion_id'),
        pm3dLinkId: query.get('link_id'), pm3dPlacement: 'campaign-landing'
      }});
      // Never forward arbitrary UTMs, ad click identifiers, query strings or private URLs.
      if ((data.link_id || data.promotion_id) && publish('campaign_landing', data)) landingSent = true;
    }
    function observe() {
      if (!privacy()) { observer?.disconnect(); return; }
      if (win.PM3DLinkCatalog) win.PM3DLinkCatalog.apply(doc,win.location.origin,config.linkCatalog);
      landing();
      if (!win.IntersectionObserver) return; // No impression claim without viewport proof.
      if (!observer) observer = new win.IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5 || published.has(entry.target)) continue;
          const data = identifiers(entry.target);
          if (data.offer_id && publish('view_offer', data)) {
            published.add(entry.target); observer.unobserve(entry.target);
          }
        }
      }, { threshold: [0.5] });
      for (const node of doc.querySelectorAll('[data-pm3d-offer-id]')) if (!published.has(node) && !node.matches?.('a,button')) observer.observe(node);
    }
    function click(event) {
      if (event.isTrusted !== true || !privacy()) return;
      const a = event.target.closest?.('a[href]');
      if (!a) return;
      const node = a.closest('[data-pm3d-offer-id], [data-pm3d-link-id]');
      if (!node) return;
      // Exclude customer service, account, legal and capability-bearing links.
      let url;
      try { url = new URL(a.href, win.location.origin); } catch (_) { return; }
      if (url.protocol !== 'https:' || /(?:^|\/)(?:account|accounts|access|order|orders|checkouts?|receipt|download|refund|withdraw|policies)(?:\/|$)/i.test(url.pathname) || url.hostname === 'downloads.premade3d.com') return;
      const data = identifiers(node);
      if (data.offer_id) publish('select_offer', data);
      if (data.link_id) publish('campaign_link', data);
    }
    doc.addEventListener('click', click);
    doc.addEventListener('visitorConsentCollected', observe);
    doc.addEventListener('shopify:section:load', observe);
    // A present API object can still be initializing; re-read only after official readiness.
    if (win.Shopify?.loadFeatures) {
      win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) observe(); });
    }
    observe();
    return { refresh: observe };
  }
  root.PM3DThemeBridge = { install };
  if (typeof module === 'object' && module.exports) module.exports = root.PM3DThemeBridge;
  if (root.document) {
    let config = {};
    try { config = JSON.parse(root.document.getElementById('PM3DTrackingConfig')?.textContent || '{}'); } catch (_) {}
    install(root, root.document, config);
  }
})(typeof window === 'object' ? window : globalThis);

/* Pure Shopify cart-discount measurement. Host supplies current authenticated-origin cart JSON;
   no fetch interception, cookies, tokens, titles or buyer fields leave this module. */
(function(root,factory){
  if(typeof module==='object'&&module.exports)module.exports=factory();
  else root.PM3DOfferSnapshot=factory();
})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict';
  const stable=v=>typeof v==='string'&&/^[a-z0-9][a-z0-9_-]{0,95}$/.test(v);
  const cents=v=>Number.isSafeInteger(v)&&v>=0;
  function mappings(config){
    const rows=Array.isArray(config?.promotions)?config.promotions:[],keys=new Map();
    const result=rows.filter(r=>{
      if(r.status!=='ACTIVE'||!stable(r.promotion_id)||!stable(r.offer_id)||!Array.isArray(config.offer_ids)||!config.offer_ids.includes(r.offer_id))return false;
      if(!/^gid:\/\/shopify\/DiscountAutomaticNode\/[0-9]+$/.test(r.shopify_discount_id||''))return false;
      if(r.identity_match==='cart_application_key'){if(typeof r.cart_application_key!=='string'||!r.cart_application_key||r.cart_application_key.length>120)return false;}
      else if(r.identity_match!=='observed_title_value_type')return false;
      if(typeof r.title!=='string'||!r.title||r.title.length>160||!r.observed_at||!r.source||r.value_type!=='percentage'||typeof r.percentage!=='number'||r.percentage<=0||r.percentage>100)return false;
      const key=r.identity_match==='cart_application_key'?r.cart_application_key:JSON.stringify([r.title,r.value_type,r.percentage]);
      keys.set(key,(keys.get(key)||0)+1);return true;
    });
    return result.filter(r=>keys.get(r.identity_match==='cart_application_key'?r.cart_application_key:JSON.stringify([r.title,r.value_type,r.percentage]))===1);
  }
  function applications(cart){
    const result=new Map();
    function add(app,amount,scope){
      if(!app||typeof app.key!=='string'||!cents(amount)||amount===0)return;
      const previous=result.get(app.key);
      if(previous){
        if(previous.app.type!==app.type||previous.app.title!==app.title||previous.app.value_type!==app.value_type||Number(previous.app.value)!==Number(app.value)){previous.invalid=true;return;}
        // Cart-level total includes line allocations. Do not count both receipts.
        if(scope==='cart'){previous.amount=amount;previous.scope='cart';}
        else if(previous.scope!=='cart')previous.amount+=amount;
      }else result.set(app.key,{app,amount,scope});
    }
    for(const app of Array.isArray(cart.cart_level_discount_applications)?cart.cart_level_discount_applications:[])add(app,app.total_allocated_amount,'cart');
    for(const line of cart.items||[])for(const allocation of Array.isArray(line.line_level_discount_allocations)?line.line_level_discount_allocations:[])add(allocation.discount_application,allocation.amount,'line');
    return [...result.values()].filter(r=>!r.invalid);
  }
  function detect(cart,config){
    if(!cart||!Array.isArray(cart.items)||typeof cart.currency!=='string')return [];
    const scale=config?.currency_scales?.[cart.currency];
    if(!Number.isSafeInteger(scale)||scale<1)return [];
    const registered=mappings(config),found=[];
    for(const receipt of applications(cart)){
      const m=registered.find(r=>{
        const keyMatched=r.identity_match==='cart_application_key'&&r.cart_application_key===receipt.app.key;
        const typeMatched=receipt.app.type==='automatic'||(keyMatched&&receipt.app.type===''&&r.allow_observed_blank_type===true&&r.observed_cart_shape&&['target_type','allocation_method','target_selection'].every(k=>receipt.app[k]===r.observed_cart_shape[k]));
        return typeMatched&&(r.identity_match==='observed_title_value_type'||keyMatched)&&r.title===receipt.app.title&&r.value_type===receipt.app.value_type&&r.percentage===Number(receipt.app.value);
      });
      if(!m)continue;
      found.push({event_name:'offer_applied',offer_id:m.offer_id,promotion_id:m.promotion_id,placement:'cart',ecommerce:{currency:cart.currency,value:receipt.amount/scale}});
    }
    return found;
  }
  function tracker(config,emit,readConsent){
    let previous=new Set();
    return function accept(cart){
      if(readConsent()?.analytics!==true){previous=new Set();return 0;}
      const active=detect(cart,config),current=new Set();let emitted=0;
      for(const e of active){
        if(previous.has(e.promotion_id))current.add(e.promotion_id);
        else if(emit(e)!==false){emitted++;current.add(e.promotion_id);}
      }
      previous=current;return emitted;
    };
  }
  return {detect,tracker};
});

/* Track adopted offers only from a fresh Shopify cart allocation receipt, never a click/count. */
(function(root){
  'use strict';
  function install(win,doc,config){
    if(!config?.enabled || !win.PM3DOfferSnapshot || !win.PM3DMeasurement || win.PM3DCartOffers?.changed)return null;
    let generation=0, sequence=0;
    function consent(){
      const p=win.Shopify?.customerPrivacy;
      try{return {analytics:win.PM3DPublicContext?.allowed(win.location,config)===true && p.currentVisitorConsent().analytics==='yes' && p.analyticsProcessingAllowed()===true,
        marketing:p.currentVisitorConsent().marketing==='yes' && p.marketingAllowed()===true};}catch(_){return {analytics:false,marketing:false};}
    }
    function emit(event){
      const c=consent();
      const eventId='offer_'+(win.crypto?.randomUUID?.() || Date.now()+'_'+(++sequence));
      const clean=win.PM3DMeasurement.sanitize(Object.assign({},event,{event_id:eventId,event_source:'storefront',consent_analytics:c.analytics,
        consent_marketing:c.marketing,page_location:win.location.origin+win.location.pathname}));
      if(!clean)return false;
      win.dataLayer=win.dataLayer||[];win.dataLayer.push({ecommerce:null,pm3d_payload:null});win.dataLayer.push({event:'pm3d_event',pm3d_payload:clean});return true;
    }
    const tracker=win.PM3DOfferSnapshot.tracker(config.offerSnapshot,emit,consent);
    function cartUrl(){
      let route='/cart';
      try{route=JSON.parse(doc.getElementById('ThemeConfig')?.textContent||'{}').routes?.cart||route;}catch(_){}
      try{
        const url=new URL(route,win.location.origin);
        if(url.origin!==win.location.origin || url.search || url.hash || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart$/.test(url.pathname))return null;
        return url.pathname+'.js';
      }catch(_){return null;}
    }
    async function refresh(){
      const current=++generation;
      if(!consent().analytics){tracker(null);return false;}
      const url=cartUrl();if(!url)return false;
      try{
        // cart/add responses can be partial; always read the current whole cart after success.
        const response=await win.fetch(url,{method:'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
        if(!response.ok)return false;
        const cart=await response.json();
        if(current!==generation || !consent().analytics || !Array.isArray(cart?.items) || !/^[A-Z]{3}$/.test(cart.currency||''))return false;
        tracker(cart);return true;
      }catch(_){return false;}
    }
    const api={changed:refresh};win.PM3DCartOffers=api;
    doc.addEventListener('visitorConsentCollected',refresh);
    // A pre-existing API object may still be initializing; its presence is not readiness.
    if(win.Shopify?.loadFeatures){
      win.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)refresh();});
    }
    // Only a consented public document makes this extra measurement read.
    refresh();
    return api;
  }
  root.PM3DCartOfferBridge={install};
  if(typeof module==='object'&&module.exports)module.exports=root.PM3DCartOfferBridge;
  if(root.document){
    let config={};try{config=JSON.parse(root.document.getElementById('PM3DTrackingConfig')?.textContent||'{}');}catch(_){}
    install(root,root.document,config);
  }
})(typeof window==='object'?window:globalThis);

/* Optional GA4 session continuity. No SDK loading, GA-cookie parsing or permission creation. */
(function(root){
 'use strict';
 function install(win,doc,config){
  if(config?.sessionTrackingEnabled!==true || !/^G-[A-Z0-9]+$/.test(config.ga4MeasurementId||'') || win.PM3DSessionHandoff)return null;
  const id=config.ga4MeasurementId;
  let ready=false,hasSession=false,generation=0,pending=null,timer=null,readinessTimer=null,readinessAttempts=0;
  function consentState(){
   const p=win.Shopify?.customerPrivacy;
   try{
    const choice=p.currentVisitorConsent()?.analytics;
    if(choice==='no')return 'no';
    return choice==='yes'&&p.analyticsProcessingAllowed()===true?'yes':'unknown';
   }catch(_){return 'unknown';}
  }
  function consent(){return consentState()==='yes';}
  function allowed(){return consent()&&win.PM3DPublicContext?.allowed(win.location,config)===true;}
  function erase(){doc.cookie='pm3d_tracking_session=; Domain=premade3d.com; Path=/; Max-Age=0; Secure; SameSite=Lax';}
  function clearReadiness(){if(readinessTimer!==null)win.clearTimeout(readinessTimer);readinessTimer=null;}
  function cancel(resetAttempts=true){generation++;hasSession=false;pending=null;if(timer!==null)win.clearTimeout(timer);timer=null;clearReadiness();if(resetAttempts)readinessAttempts=0;}
  function existingDestination(){try{return Boolean(win.google_tag_manager?.[id]);}catch(_){return false;}}
  function session(value){
   if(typeof value==='string'&&/^[1-9][0-9]{0,15}$/.test(value))value=Number(value);
   return Number.isSafeInteger(value)&&value>0?value:null;
  }
  function refresh(){
   if(!consent()){cancel(false);erase();return false;}
   // Native Google can be ready without ever executing the optional custom-event runtime.
   if(!ready&&existingDestination())ready=true;
   if(!allowed()||!ready||pending!==null||!Array.isArray(win.dataLayer))return false;
   hasSession=false;
   const current=++generation;pending=current;
   timer=win.setTimeout(function(){if(pending===current){pending=null;timer=null;generation++;}},1500);
   function receive(value){
    if(pending!==current||generation!==current)return;
    pending=null;if(timer!==null)win.clearTimeout(timer);timer=null;
    if(!allowed())return;
    const sessionId=session(value);if(sessionId===null)return;
    hasSession=true;clearReadiness();
    const encoded=encodeURIComponent(JSON.stringify({v:1,session_id:sessionId,updated_at:Date.now()}));
    doc.cookie='pm3d_tracking_session='+encoded+'; Domain=premade3d.com; Path=/; Max-Age=1800; Secure; SameSite=Lax';
   }
   // Official gtag command envelope, using the already existing queue. Never loads or configures a tag.
   function gtag(){win.dataLayer.push(arguments);}
   gtag('get',id,'session_id',receive);
   return true;
  }
  function watchReadiness(){
   const requested=refresh();
   // Destination readiness does not establish a valid session. Retry undefined callbacks/timeouts too.
   const choice=consentState();
   if(!hasSession&&(choice==='unknown'||allowed())&&readinessTimer===null&&readinessAttempts<8){
    readinessTimer=win.setTimeout(function(){readinessTimer=null;readinessAttempts++;watchReadiness();},1000);
   }
   return requested;
  }
  function markReady(measurementId){if(measurementId!==id)return false;ready=true;clearReadiness();return watchReadiness();}
  function privacyChanged(){cancel();if(consentState()==='no')erase();else watchReadiness();}
  win.addEventListener('pm3d:ga4-ready',function(event){markReady(event.detail?.measurement_id);});
  win.addEventListener('pageshow',watchReadiness);
  win.addEventListener('load',watchReadiness);
  doc.addEventListener('visitorConsentCollected',privacyChanged);
  const api={ready:markReady,refresh:watchReadiness};win.PM3DSessionHandoff=api;
  if(win.Shopify?.loadFeatures)win.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error)privacyChanged();});
  watchReadiness();
  return api;
 }
 root.PM3DSessionBridge={install};
 if(typeof module==='object'&&module.exports)module.exports=root.PM3DSessionBridge;
 if(root.document){
  let config={};try{config=JSON.parse(root.document.getElementById('PM3DTrackingConfig')?.textContent||'{}');}catch(_){}
  install(root,root.document,config);
 }
})(typeof window==='object'?window:globalThis);
